import { Languages } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

const LANGS = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

const LanguageSwitcher = ({ dark = false, suffix = "" }) => {
  const { lang, setLang } = useI18n();
  const id = (base) => (suffix ? `${base}-${suffix}` : base);
  return (
    <div
      data-testid={id("language-switcher")}
      className={`flex items-center gap-1 rounded-md border p-0.5 ${
        dark ? "border-slate-700" : "border-slate-200 bg-white"
      }`}
    >
      <Languages className={`ml-1.5 h-3.5 w-3.5 ${dark ? "text-slate-400" : "text-slate-400"}`} />
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={id(`lang-${l.code}`)}
          onClick={() => setLang(l.code)}
          className={`rounded px-2 py-1 text-xs font-bold transition-colors duration-200 ${
            lang === l.code
              ? "bg-slate-900 text-white"
              : dark
                ? "text-slate-400 hover:text-white"
                : "text-slate-500 hover:text-slate-900"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
